var _rect, _path, _mask, _path2, _line, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRecord(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 5.5,
    width: 4,
    height: 10,
    stroke: "#0AA1E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 15.691V5.30902L13.5 0.809017V20.191L4.5 15.691Z",
    stroke: "#0AA1E2"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 7C13.5253 7 14.0454 7.10346 14.5307 7.30448C15.016 7.5055 15.457 7.80014 15.8284 8.17157C16.1999 8.54301 16.4945 8.98396 16.6955 9.46927C16.8965 9.95457 17 10.4747 17 11C17 11.5253 16.8965 12.0454 16.6955 12.5307C16.4945 13.016 16.1999 13.457 15.8284 13.8284C15.457 14.1999 15.016 14.4945 14.5307 14.6955C14.0454 14.8965 13.5253 15 13 15L13 11L13 7Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 7C13.5253 7 14.0454 7.10346 14.5307 7.30448C15.016 7.5055 15.457 7.80014 15.8284 8.17157C16.1999 8.54301 16.4945 8.98396 16.6955 9.46927C16.8965 9.95457 17 10.4747 17 11C17 11.5253 16.8965 12.0454 16.6955 12.5307C16.4945 13.016 16.1999 13.457 15.8284 13.8284C15.457 14.1999 15.016 14.4945 14.5307 14.6955C14.0454 14.8965 13.5253 15 13 15L13 11L13 7Z",
    stroke: "#0AA1E2",
    strokeWidth: 2,
    mask: "url(#path-3-inside-1)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17.686,
    y1: 13.8285,
    x2: 21.8285,
    y2: 16.314,
    stroke: "#0AA1E2",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 5.33095,
    y2: -0.5,
    transform: "matrix(0.857493 -0.514496 -0.514496 -0.857493 17 9)",
    stroke: "#0AA1E2",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 18.5,
    y1: 11.5,
    x2: 24.5,
    y2: 11.5,
    stroke: "#0AA1E2",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecord);
export default __webpack_public_path__ + "static/media/iconRecord.9024c33511819047c349ef22d8d96f6e.svg";
export { ForwardRef as ReactComponent };